module.exports = "data:image/webp;base64,UklGRjAAAABXRUJQVlA4TCQAAAAvJ4AGACDMNgIawfmDnUKfAoEkf795FggkJuGvef/zzzwxF2Y="